import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32550608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cash-filters__container" }
const _hoisted_2 = { class: "cash-filters__actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "cash-filters",
    onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_input, {
        placeholder: "Дата статуса оплаты",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.date) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_select, {
        placeholder: "Курьер",
        "can-deselect": "",
        "search-without-refresh": "",
        label: "fullName",
        searchBy: "fullName",
        disabled: _ctx.loading,
        loading: _ctx.data_state.couriers.is_loading,
        failed: _ctx.data_state.couriers.is_failed,
        options: _ctx.data_state.couriers.list,
        value: _ctx.state.courierId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.courierId) = $event)),
        onRefresh: _ctx.loadCouriers
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_input, {
        placeholder: "Номер накладной",
        disabled: _ctx.loading,
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.invoiceNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_select, {
        placeholder: "Статус оплаты",
        "can-deselect": "",
        "search-without-refresh": "",
        multiselect: "",
        searchable: false,
        disabled: _ctx.loading,
        options: _ctx.STATUSES,
        value: _ctx.state.statusIds,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.statusIds) = $event))
      }, null, 8, ["disabled", "options", "value"]),
      _createVNode(_component_new_select, {
        placeholder: "Дисп. сектор отправителя",
        "can-deselect": "",
        "search-without-refresh": "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.dispatcherSectors.is_loading,
        failed: _ctx.data_state.dispatcherSectors.is_failed,
        options: _ctx.data_state.dispatcherSectors.list,
        value: _ctx.state.senderDispatcherSectorId,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.senderDispatcherSectorId) = $event)),
        onRefresh: _ctx.loadDispatcherSectors
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Дисп. сектор получателя",
        "can-deselect": "",
        "search-without-refresh": "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.dispatcherSectors.is_loading,
        failed: _ctx.data_state.dispatcherSectors.is_failed,
        options: _ctx.data_state.dispatcherSectors.list,
        value: _ctx.state.receiverDispatcherSectorId,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.receiverDispatcherSectorId) = $event)),
        onRefresh: _ctx.loadDispatcherSectors
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Статус накладной",
        "can-deselect": "",
        "search-without-refresh": "",
        searchable: false,
        disabled: _ctx.loading,
        loading: _ctx.data_state.invoiceStatuses.is_loading,
        failed: _ctx.data_state.invoiceStatuses.is_failed,
        options: _ctx.data_state.invoiceStatuses.list,
        value: _ctx.state.invoiceStatusId,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.invoiceStatusId) = $event)),
        onRefresh: _ctx.loadInvoiceStatuses
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Город отправления",
        "can-deselect": "",
        "search-without-refresh": "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        options: _ctx.data_state.cities.list,
        value: _ctx.state.senderCity,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.senderCity) = $event)),
        onRefresh: _ctx.loadCities
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Город прибытия",
        "can-deselect": "",
        "search-without-refresh": "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        options: _ctx.data_state.cities.list,
        value: _ctx.state.receiverCity,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.receiverCity) = $event)),
        onRefresh: _ctx.loadCities
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Менеджер",
        "can-deselect": "",
        "search-without-refresh": "",
        multiselect: "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.managers.is_loading,
        failed: _ctx.data_state.managers.is_failed,
        options: _ctx.data_state.managers.list,
        value: _ctx.state.managerIds,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.managerIds) = $event)),
        onRefresh: _ctx.loadManagers
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_select, {
        placeholder: "Клиент",
        "can-deselect": "",
        "search-without-refresh": "",
        multiselect: "",
        disabled: _ctx.loading,
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        options: _ctx.data_state.companies.list,
        value: _ctx.state.companyIds,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.companyIds) = $event)),
        onRefresh: _ctx.loadCompanies
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата от",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.dateFrom,
        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.dateFrom) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата по",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.dateTo,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.dateTo) = $event))
      }, null, 8, ["disabled", "value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_new_button, {
        type: "button",
        disabled: _ctx.loading,
        class: "NewButton--reset",
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_new_button, {
        type: "submit",
        loading: _ctx.loading,
        class: "NewButton--search"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}